module.exports = __webpack_public_path__ + "static/img/CT_6.c3e388d0.png";